
import Vue from 'vue'
import BHeader from './components/header'
import BFooter from './components/footer'
import { BLoading } from './components/loading'


export default Vue.extend({
    components: { BHeader, BFooter, BLoading },
    data() {
        return {
            loading: window.location.search.search('no-loading') < 0
        }
    },
})
